import { useDisconnectDishFromSatellite } from 'features/dishes/api/disconnectDishFromSatellite';
import { useDeleteAnalyzerDish } from '../../dishes/api/deleteAnalyzerDish';
import { useDish } from '../../dishes/api/getDish';
import { useUpdateDish } from '../../dishes/api/updateDish';
import { useUngroupAnalyzerAndSwitch } from '../../switches/api/ungroupAnalyzerAndSwitch';

export const useUnlinkNodesHandler = (selectedNode: string) => {
  const splitNode = selectedNode.split('-');
  const updateDish = useUpdateDish({});
  const disconnectDishFromSatellite = useDisconnectDishFromSatellite({});
  const ungroupAnalyzerAndSwitch = useUngroupAnalyzerAndSwitch({
    analyzerId: Number(splitNode[2]),
  });
  let selectedDishId = -1;
  let selectedSwitchId = -1;
  let selectedAnalyzerId = -1;
  if (selectedNode.startsWith('dishSwitch')) {
    selectedDishId = Number(splitNode[1]);
    selectedSwitchId = Number(splitNode[2]);
  }
  if (selectedNode.startsWith('dishAnalyzer')) {
    selectedDishId = Number(splitNode[1]);
    selectedAnalyzerId = Number(splitNode[2]);
  }
  const { data: dish } = useDish({ dishId: selectedDishId });
  const removeAnalyzerDish = useDeleteAnalyzerDish({});
  const unlinkNodesHandler = () => {
    if (selectedNode.startsWith('satelliteDish')) {
      const satelliteId = Number(splitNode[1]);
      const dishId = Number(splitNode[2]);
      disconnectDishFromSatellite.mutateAsync({
        satellite_id: satelliteId,
        dish_id: dishId,
      });
    }
    if (selectedNode.startsWith('locationDish')) {
      const dishId = Number(splitNode[2]);
      updateDish.mutateAsync({ dishId, data: { location_id: null } });
    }
    if (selectedNode.startsWith('dishSwitch')) {
      const connectionToRemove = dish?.analyzer_dish.find(
        (connection) =>
          connection.dish_id === selectedDishId &&
          connection.switch_id === selectedSwitchId
      );
      if (connectionToRemove)
        removeAnalyzerDish.mutateAsync(connectionToRemove.id);
    }
    if (selectedNode.startsWith('switchAnalyzer')) {
      ungroupAnalyzerAndSwitch.mutateAsync({
        data: {
          analyzerId: Number(splitNode[2]),
          switchId: Number(splitNode[1]),
        },
      });
    }
    if (selectedNode.startsWith('dishAnalyzer')) {
      const connectionToRemove = dish?.analyzer_dish.find(
        (connection) =>
          connection.dish_id === selectedDishId &&
          connection.analyzer_id === selectedAnalyzerId
      );
      if (connectionToRemove)
        removeAnalyzerDish.mutateAsync(connectionToRemove.id);
    }
  };
  return unlinkNodesHandler;
};
